import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import { ReactNode } from 'react';

type Props = {
    value: string | number | null | undefined;
    textareaClassName?: string;
    noresize?: boolean;
    error?: ReactNode;
} & Omit<React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>, 'value'>;

export default function TextArea({
    className,
    textareaClassName,
    style,
    value,
    noresize = false,
    error,
    ...otherProps
}: Props) {
    const inputProps = {
        ...otherProps,
        className: classNames(textareaClassName, { no_resize: !!noresize }),
        value: value || '',
    };
    const wrapperProps = {
        style,
        className: classNames(className, 'react-text_area', {
            'react-text_area-error': !!error,
        }),
    };
    return (
        <div {...wrapperProps}>
            <textarea {...inputProps} />
            {!!error && <div className="react-text_area-error_box">{error}</div>}
        </div>
    );
}

TextArea.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
    className: PropTypes.string,
    textareaClassName: PropTypes.string,
    style: PropTypes.object,
    error: PropTypes.string,
    disabled: PropTypes.bool,
    rows: PropTypes.number,
    noresize: PropTypes.bool,
};
